import styled, { css } from 'styled-components'

import { white, red, mediumgray, bordergray, inputgray } from '../../styles/colors'
import { maxmedia, minmedia } from '../../styles/media-queries'

export const Container = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: stretch;

  ${maxmedia.large`
    display: none;
  `}
`

export const Button = styled.div`
  cursor: pointer;
  transition: all 0.5s;
  border-radius: 0.25rem;
  padding: 0.75rem 1.5rem;
  margin-right: 0.5rem;
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
  color: ${mediumgray};
  font-weight: 300;
  border: 1px solid ${bordergray};
  background: ${white};
  &:last-child {
    margin-right: 0;
  }
  &:hover {
    color: ${white};
    background: ${red};
    border: 1px solid ${red};
  }
  ${props =>
    props.active &&
    css`
      color: ${white};
      background: ${red};
      border: 1px solid ${red};
    `};
`

export const MobileContainer = styled.div`
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1rem;

  ${minmedia.medium`
    width: 50%;
    margin-bottom: 0; //reset
  `}

  ${minmedia.large`
    display: none;
  `}
`

export const Title = styled.p`
  color: ${mediumgray};
  margin: 0;
  font-size: 16px;
  width: 110px;
`

export const StyledSelect = styled.select`
  appearance: none;
  width: calc(100% - 110px);
  box-sizing: border-box;
  padding: 0.75rem 1rem;
  min-height: 48px; //match search input

  font-size: 16px;
  font-weight: 300;
  border: 1px solid ${bordergray};
  border-radius: 0.25rem;

  background-color: ${white};
  background-image: url(${props => props.chevron});
  background-position: calc(100% - 14px) center;
  background-repeat: no-repeat;
  background-size: 20px 20px;

  &:focus {
    border: 1px solid ${inputgray};
    box-shadow: 0px 0px 5px 0px ${inputgray};
    outline: none;
  }

  &::-ms-expand {
    display: none;
  }
`


// WEBPACK FOOTER //
// ./src/components/Filter/styles.js